import axios from 'axios';
import { getCvAccessToken, setupAxios, UserRefreshToken, getUserState } from '@carvana/core-auth';

import { BASE_API_URL } from './helpers';

const authenticatedAxios = setupAxios(axios.create({ baseURL: BASE_API_URL }), {
  addBearerTokenToAllRequests: true
});

authenticatedAxios.interceptors.request.use(async (config) => {
  if (config.data && typeof config.data === 'object') {
    try {
      const { isLoggedIn } = getUserState();
      if (isLoggedIn) {
        const currentAccessToken = getCvAccessToken();
        if (!currentAccessToken) {
          const refreshSuccess = await UserRefreshToken();
          if (refreshSuccess) {
            const freshToken = getCvAccessToken();
            if (freshToken) {
              config.headers.Authorization = `Bearer ${freshToken}`;
            }
          }
        }
      }
    } catch {
      // If verification fails, continue with request - let existing handlers deal with it
    }
  }
  return config;
});

export default authenticatedAxios;